import React from 'react'
import Navbar from '../inc/Navbar'
import Table from 'react-bootstrap/Table';
import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";


function Schooltiming() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
           <div className="album py-1">
                <div className="container">
                    <h1> KRISHNAGAR PUBLIC SCHOOL </h1>
                </div>
            </div>

            <div className='cbscschoolnadia'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">School & Class Timing <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <ScrollToTop smooth top="100" color="darkgoldenrod" />


            <div className='visitingtimeschool'>
                <br />
                <div className="album py-0">
                    <div className="container">
                       

                        <div className="card-body">
                            <div className='welcometext'>
                                <h1 className="card-title mb-0"><b>School  Timing</b></h1>
                                <div className="col-md-5">
                                    <hr style={{ color: "#1D4D93" }} />
                                </div>
                            </div>
                        </div>
                         <h5 className='mb-2'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar2-check" viewBox="0 0 16 16">
  <path d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0"/>
  <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"/>
  <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z"/>
</svg> Working Days : Monday to Friday</h5>
                    </div>
                </div>

                <div className="album py-1">
                    <div className="container">
                        <center>
                        <h5><b>WORKING HOURS</b></h5>
</center>
                        <Table striped bordered hover variant="light">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Student's Entry :</th>
                                    <th>08:45 am</th>

                                </tr>
                            </thead>
                            <tbody>
                                
                                <tr>
                                    <td>1</td>
                                    <td>Playgroup to KG</td>
                                    <td>9:00 am to 12:05 pm</td>

                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td >Classes I & II</td>
                                    <td>9:00 am to 12:45 pm</td>

                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td >Class II to X :</td>
                                    <td>9:00 am to 3:00 pm</td>

                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td >Class XI & XII</td>
                                    <td>9:00 am to 3:40 pm</td>

                                </tr>



                                <tr>


                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </div>


                <br />

                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 className="card-title mb-0"><b> Class Timing</b></h1>
                            <div className="col-md-5">
                                <hr style={{ color: "#1D4D93" }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="album py-1">
                    <div className="container">

                        <Table striped bordered hover variant="primary">
                            <thead>
                                <tr>
                                    <th>Period</th>
                                    <th>Starts</th>
                                    <th>Ends</th>
                                    <th>Duration</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1st Period</td>
                                    <td>09:15 am</td>
                                    <td>09:55 am</td>
                                    <td>40 minutes</td>
                                </tr>
                                <tr>
                                    <td>2nd Period</td>
                                    <td>09:55 am</td>
                                    <td>10:35 am</td>
                                    <td>40 minutes</td>

                                </tr>
                                <tr>
                                    <td>3rd Period</td>
                                    <td >10:35 am</td>
                                    <td>11:15 am</td>
                                    <td>40 minutes</td>

                                </tr>
                                <tr>
                                    <td>Short Break</td>
                                    <td >11:15 am</td>
                                    <td>11:25 pm		</td>
                                    <td>10 minutes</td>

                                </tr>
                                <tr>
                                    <td>4th Period</td>
                                    <td >11:25 pm</td>
                                    <td>12:05 pm</td>
                                    <td>40 minutes</td>

                                </tr>



                                <tr>
                                    <td>5th Period</td>
                                    <td >12:05 pm</td>
                                    <td>12:45 pm</td>
                                    <td>40 minutes</td>

                                </tr>

                                <tr>
                                    <td>6th Period</td>
                                    <td >12:45 pm</td>
                                    <td>01:25 pm</td>
                                    <td>40 minutes</td>

                                </tr>


                                <tr>
                                    <td>Long Break</td>
                                    <td >01:25 pm</td>
                                    <td>01:45 pm</td>
                                    <td>20 minutes</td>

                                </tr>

                                <tr>
                                    <td>7th Period</td>
                                    <td >01:45 pm</td>
                                    <td>02:25 pm</td>
                                    <td>40 minutes</td>

                                </tr>
                                    <tr>
                                    <td>8th Period</td>
                                    <td >02:25 pm</td>
                                    <td>03:00 pm</td>
                                    <td>35 minutes</td>

                                </tr>
                                    <tr>
                                    <td>9th Period</td>
                                    <td >03:00 pm</td>
                                    <td>03:40 pm</td>
                                    <td>40 minutes</td>

                                </tr>

                                
                            </tbody>
                        </Table>
                    </div>
                </div>

            </div>




        </div>
    )
}

export default Schooltiming